export const PLATFORM_ORDER_NAV = [
  { scope: 'all', key: 'all', path: '/dashboard/admin/platform-orders' },
  { scope: 'membership', key: 'membership', path: '/dashboard/admin/platform-orders/membership' },
  { scope: 'recharge', key: 'recharge', path: '/dashboard/admin/platform-orders/recharge' },
  { scope: 'bank', key: 'bank', path: '/dashboard/admin/platform-orders/bank-transfers' }
]
